import { WindowState } from '../state';
import { LAYOUT_PRESETS } from '../layout/presets';
import { parseLayoutExpression } from '../layout/parser';
import { resolveLayout } from '../layout/resolver';

export function createLayoutPicker(state: WindowState, onChange: () => void): HTMLElement {
  const container = document.createElement('div');

  const grid = document.createElement('div');
  grid.className = 'layout-grid';

  for (const [id, preset] of Object.entries(LAYOUT_PRESETS)) {
    const thumb = document.createElement('div');
    thumb.className = 'layout-thumb';
    if (state.config.layout.presetId === id) thumb.classList.add('active');
    thumb.title = preset.name;
    thumb.innerHTML = renderLayoutSVG(preset.expression);

    thumb.addEventListener('click', () => {
      state.setLayout(id);
      onChange();
    });

    grid.appendChild(thumb);
  }

  container.appendChild(grid);
  return container;
}

function renderLayoutSVG(expression: string): string {
  const ast = parseLayoutExpression(expression);
  const rects = resolveLayout(ast, { x: 0, y: 0, width: 1, height: 1 });

  const svgW = 48;
  const svgH = 64;
  const pad = 3;
  const iw = svgW - 2 * pad;
  const ih = svgH - 2 * pad;
  const gap = 1.5;

  let rhtml = '';
  for (const r of rects) {
    const sx = pad + r.x * iw + gap / 2;
    const sy = pad + (1 - r.y - r.height) * ih + gap / 2;
    const sw = r.width * iw - gap;
    const sh = r.height * ih - gap;
    const cx = sx + sw / 2;
    const cy = sy + sh / 2;
    const fontSize = Math.min(sw, sh) < 10 ? 4 : 6;
    rhtml += `<rect x="${sx}" y="${sy}" width="${sw}" height="${sh}" fill="#e8f0fe" stroke="#888" stroke-width="1" rx="1"/>`;
    rhtml += `<text x="${cx}" y="${cy}" text-anchor="middle" dominant-baseline="central" font-size="${fontSize}" font-family="system-ui,sans-serif" font-weight="700" fill="#2563eb">${r.index}</text>`;
  }

  return `<svg viewBox="0 0 ${svgW} ${svgH}" xmlns="http://www.w3.org/2000/svg">${rhtml}</svg>`;
}
